module.exports = __webpack_public_path__ + "img/icon_tools_white.a0a0d993.png";